export default __webpack_public_path__ + "static/media/delete.0ce72247.svg";